import Vue from 'vue';
import { LANGS, DEFAULT_LANG, readLang, writeLang } from '@/utils/lang';
import ja from '@/locales/ja.json';
import en from '@/locales/en.json';

const dicts = { ja, en };

const state = Vue.observable({ lang: DEFAULT_LANG });

const warned = new Set();
const warnMissing = (key, lang) => {
  if (process.env.NODE_ENV === 'production') return;
  const tag = lang + ':' + key;
  if (warned.has(tag)) return;
  warned.add(tag);
  // eslint-disable-next-line no-console
  console.warn('[i18n] missing ' + lang + ' translation for: ' + key);
};

const translate = (key, params) => {
  const dict = dicts[state.lang] || {};
  let str = dict[key];
  if (typeof str !== 'string') {
    if (state.lang !== 'ja') warnMissing(key, state.lang);
    str = key;
  }
  if (params) {
    Object.keys(params).forEach((p) => {
      str = str.replace(new RegExp('\\{' + p + '\\}', 'g'), String(params[p]));
    });
  }
  return str;
};

// Named exports for non-Vue JS modules (Formatter.js, SBPVisualizer.js, etc.)
// state.lang is updated by setLang() so this stays current at call time.
export const t = (key, params) => translate(key, params);
export const getLang = () => state.lang;

export default {
  install (VueInstance) {
    state.lang = readLang();

    Object.defineProperty(VueInstance.prototype, '$lang', {
      get () { return state.lang; }
    });

    VueInstance.prototype.$langs = LANGS;

    VueInstance.prototype.$t = function (key, params) {
      return translate(key, params);
    };

    VueInstance.prototype.$setLang = function (lang) {
      if (LANGS.indexOf(lang) === -1) return;
      state.lang = lang;
      writeLang(lang);
    };
  }
};



// WEBPACK FOOTER //
// ./src/plugins/i18n.js